import React from "react";
import { SpacingCustom } from "../../layout/Spacing/SpacingCustom";
import { DashboardListBar } from "./DashboardList/DashboardListBar";
import { IBasicDetails, TDisplay } from "../../../interface/interfaces";

interface IDashboardBarProps {
    node: IBasicDetails,
    display?:TDisplay,
}

export const DashboardBar: React.FC<IDashboardBarProps> = ({node, display}) => {


    const ok = node.StatusBar?.Ok ?? 0;
    const warning = node.StatusBar?.Warning ?? 0;
    const error = node.StatusBar?.Error ?? 0;
    const unknown = node.StatusBar?.Unknown ?? 10;

    const total = ok + warning + error + unknown;
    const rest = (node.StatusScale ?? 10) - total;

    const scale = total > 0 ? 100 / (total + rest) : 0;


    return (
        <SpacingCustom paddingRight={display === 'grid' ? 0 : 1}>
            <div className="dashboard-item__bar">
                <DashboardListBar statusScale={scale} statusValue={ok} colorHash={"#77b800"}/>
                <DashboardListBar statusScale={scale} statusValue={warning} colorHash={"#f07b05"}/>
                <DashboardListBar statusScale={scale} statusValue={error} colorHash={"#e1142c"}/>
                <DashboardListBar statusScale={scale} statusValue={unknown} colorHash={"#a0a2a3"}/>
                <DashboardListBar darkBg = {false} statusScale={scale} statusValue={rest} colorHash={"#ededed"}/>
            </div>
        </SpacingCustom>
    );
}